import {config as vuexModuleDecoratorsConfig} from 'vuex-module-decorators';
// https://github.com/championswimmer/vuex-module-decorators/issues/224#issuecomment-628763207
vuexModuleDecoratorsConfig.rawError = true;
